import { gql } from '@efficiently/client-core-graphql-models';

export const CONFIRM_PLAN_DETECTION = gql(`
	mutation ConfirmPlanDetection($planItemId: String!) {
		confirmPlanDetection(planItemId: $planItemId) {
			roomIds
			spaceIds
			constructionIds
		}
	}
`);
